export default "__VITE_ASSET__Cf60O8Fq__"